'use client'

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

import useLanguages from '@/store/helpers/swr/use-languages'

export default function LanguageField({ form }) {
  const { languages } = useLanguages()
  return (
    <FormField
      control={form.control}
      name="languages"
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            <h5 className="text-h-5-sm font-medium">
              What languages does your community speak?
            </h5>
          </FormLabel>
          <Select onValueChange={field.onChange} defaultValue={field.value}>
            <FormDescription className="-mb-2 text-p-1 font-semibold text-neutral-blue-200">
              Select Language
            </FormDescription>
            <FormControl>
              <SelectTrigger className="border-neutral-blue-700! bg-neutral-blue-800! w-full">
                <SelectValue placeholder="Select Language" />
              </SelectTrigger>
            </FormControl>
            <SelectContent className="bg-neutral-blue-800!">
              <div className="max-h-[300px]! overflow-y-auto">
                {languages?.map((language) => (
                  <SelectItem key={language.value} value={language.value}>
                    {language.label}
                  </SelectItem>
                ))}
              </div>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
